import { render, staticRenderFns } from "./distributorpolicy.vue?vue&type=template&id=d4f858ca&scoped=true"
import script from "./distributorpolicy.vue?vue&type=script&lang=js"
export * from "./distributorpolicy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4f858ca",
  null
  
)

export default component.exports